import React, { useState } from "react";
import { CommandBarButton, Aside } from "sprint-common-web";

import { CreateAsperaDeliveryEndpointForm } from "../../aspera/CreateAsperaDeliveryEndpointForm";
import { CreateSigniantDeliveryEndpointForm } from "../../signiant/CreateSigniantDeliveryEndpointForm";
import { CreateSmartjogDeliveryEndpointForm } from "./CreateSmartjogDeliveryEndpointForm";

export const AddDeliveryEndpointButton: React.FC = () => {
    const [isSmartjogSidebarOpen, setIsSmartjogSidebarOpen] = useState<boolean>(false);
    const [isAsperaSidebarOpen, setIsAsperaSidebarOpen] = useState<boolean>(false);
    const [isSigniantSidebarOpen, setIsSigniantSidebarOpen] = useState<boolean>(false);

    const closeSmartjogSidebar = () => {
        setIsSmartjogSidebarOpen(false);
    };

    const openSmartjogSidebar = () => {
        setIsSmartjogSidebarOpen(true);
    };

    const closeAsperaSidebar = () => {
        setIsAsperaSidebarOpen(false);
    };

    const openAsperaSidebar = () => {
        setIsAsperaSidebarOpen(true);
    };
    const closeSigniantSidebar = () => {
        setIsSigniantSidebarOpen(false);
    };

    const openSigniantSidebar = () => {
        setIsSigniantSidebarOpen(true);
    };

    const getMenuItems = () => {
        return [
            {
                text: "Smartjog",
                icon: "Add",
                onClick: openSmartjogSidebar
            },
            {
                text: "Aspera",
                icon: "Add",
                onClick: openAsperaSidebar
            },
            {
                text: "Signiant",
                icon: "Add",
                onClick: openSigniantSidebar
            }
        ];
    };

    return (
        <>
            <CommandBarButton text="Add" icon="Add" menuItems={getMenuItems()} />
            <Aside
                isOpen={isSmartjogSidebarOpen}
                type="form"
                headerText="Add Smartjog delivery endpoint"
                onDismiss={closeSmartjogSidebar}
            >
                <CreateSmartjogDeliveryEndpointForm onCancel={closeSmartjogSidebar} onSubmit={closeSmartjogSidebar} />
            </Aside>
            <Aside
                isOpen={isAsperaSidebarOpen}
                type="form"
                headerText="Add Aspera delivery endpoint"
                onDismiss={closeAsperaSidebar}
            >
                <CreateAsperaDeliveryEndpointForm onCancel={closeAsperaSidebar} onSubmit={closeAsperaSidebar} />
            </Aside>
            <Aside
                isOpen={isSigniantSidebarOpen}
                type="form"
                headerText="Add Signiant delivery endpoint"
                onDismiss={closeSigniantSidebar}
            >
                <CreateSigniantDeliveryEndpointForm onCancel={closeSigniantSidebar} onSubmit={closeSigniantSidebar} />
            </Aside>
        </>
    );
};
